import { Box, Button, Drawer } from "@mui/material"
import React from "react"
import { useState } from "react"
import { HtmlComponent, TreeView } from "../../../components"
import { Link } from "react-router-dom"
import { getResponsiveSize, getRouteToName } from "../../../util"
import { sessionStore } from "../../../services"
import { CloseIconNew, MenuIconNew } from "../../../../style/images"

export const SideMenuBar = (props)=>{
    const [toggle, setToogle] = useState(false)

    const onToggle=()=>{
        setToogle(!toggle)
        props.setBlur(!toggle)
    }

    const isActiveNode = currentNode => item => {
        // a node is active if it is the current node or one of it's children
        return currentNode.name === item.name || item.children.any( isActiveNode( currentNode ) );
      };
      const nodeClick = item =>{
        if(item.isSelector || item.isConfigurator){
            onToggle()
        }
      }
    const getItemItemplate = item => {
        const htmlComponent = <HtmlComponent item={ item.name } tooltip={ item.name } />;
        return item.isExternal 
          ? <a href={ item.libraryLink } target={ '_blank' }>{ htmlComponent }</a> 
          : <Link to={ getRouteToName( item ) } onClick={()=>nodeClick(item)}>{ htmlComponent }</Link>;
      }
    const defaultTreeViewWidth = 320;
    const [treeViewWidth, setTreeViewWidth] = useState(sessionStore.get( 'treeViewWidth' ) || getResponsiveSize( defaultTreeViewWidth )) 
    return(
        <>
        <div className="side-menu-bar">
            <Button sx={{padding:"0px"}} onClick={onToggle} disableRipple style={{ backgroundColor: 'transparent' }} ><Box component="img" src={MenuIconNew}></Box></Button>
        </div>
        {/* <Drawer
                BackdropProps={{ invisible: true }}
                anchor="left"
                open={toggle}
                onClose={onToggle}
                PaperProps={{sx:{top:74}}}
            > */}
            {toggle&&<div className="menu-drawer" style={{
                // width:"calc(20% + 60px)"
                width:"435px"}}>
            <Box sx={{display:"flex", flexDirextion:"row", height:"100%"}}>
                <div className="side-menu-bar">
                    <Button sx={{padding:"0px"}} onClick={onToggle} disableRipple style={{ backgroundColor: 'transparent' }}><Box component="img" src={CloseIconNew}></Box></Button>
                </div>
                <div style={{height:"100%", width:"100%", overflowY:"auto"}}>
                <TreeView data={ props.node } 
                    collapsible={ false } 
                    childProperty="children"
                    isActive={ isActiveNode( props.currentNode ) }
                    itemTemplate={ getItemItemplate }
                    width={treeViewWidth }
                    border="0px solid #EBEBEB"
                    ></TreeView>
                </div>
            </Box>
            {/* </Drawer> */}
            </div>}
            {toggle&&<div className="blur-effect" style={{width:"calc(100% - 435px)", left:"435px "}} onClick={onToggle}>

            </div>}
            </>
    )
}